import { anyObject } from '../types/helpers';

export const clear = (obj: anyObject) => Object.fromEntries(Object.entries(obj).filter((el) => Boolean(el[1])));
